import { useChatInbox } from '../context/ChatInboxContext';

export function useChatUnread(isGuest) {
  const { unreadTotal, refreshUnread } = useChatInbox();

  if (isGuest) {
    return { unreadTotal: 0, refreshUnread: () => {} };
  }

  return { unreadTotal, refreshUnread };
}
